// import {QUERY_KEYS as AUTHENTICATION_QUERY_KEYS} from '@/features/authentication/queries/keys'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {sendMicromorgiV3} from '../services/micromorgi.http'
import {SendMicromorgiParamsV3} from '../types'
import {MUTATION_KEYS} from './keys'
import {QUERY_KEYS as AUTHENTICATION_QUERY_KEYS} from '@/features/authentication/queries/keys'
import {QUERY_KEYS as CHAT_QUERY_KEYS} from '@/features/chat/queries/keys'

import {UserV3} from '@/features/authentication/types'
import {USER_ROLE_GUEST} from '@/utilities/constants/user'
import {generateChatChannelName} from '@/utilities/helpers'
import {useGetRepresentedUser} from '@/hooks/useGetRepresentedHost'
import {useMe} from '@/features/authentication/queries/useMe'

export const useSendMicromorgi = (onSuccess?: () => void) => {
    const queryClient = useQueryClient()
    const {representedUserId} = useGetRepresentedUser()
    const {data: user} = useMe()
    return useMutation({
        mutationKey: [MUTATION_KEYS.send_micromorgi],
        mutationFn: (props: SendMicromorgiParamsV3) => sendMicromorgiV3(props),
        onSuccess: (_, props) => {
            onSuccess?.()
            queryClient.setQueryData([AUTHENTICATION_QUERY_KEYS.user], (oldUser: UserV3) => {
                if (!('microMorgiBalance' in oldUser.typeAttributes)) return oldUser
                return {
                    ...oldUser,
                    typeAttributes: {
                        ...oldUser.typeAttributes,
                        microMorgiBalance: oldUser.typeAttributes.microMorgiBalance - (props.micromorgiAmount ?? 0)
                    }
                }
            })

            if (user)
                queryClient.invalidateQueries({
                    queryKey: [
                        CHAT_QUERY_KEYS.fetchChannelDetailsV3,
                        generateChatChannelName(user.id, USER_ROLE_GUEST, +props.creatorId),
                        representedUserId
                    ]
                })
        }
    })
}
